<template>
  <div class="custom-tag">
    <div :class="['custom-tag-label', type]">
      {{ label }}
      <el-tooltip
        v-if="!!content"
        effect="light"
        placement="top"
      >
        <template #content>
          <span style="white-space: pre-wrap" v-html="content" />
        </template>
        <svg-icon :class="type" icon="material-symbols:error-outline-rounded" />
      </el-tooltip>
    </div>
  </div>
</template>
<script setup lang='ts'>
import { PropType } from 'vue';
import SvgIcon from '../SvgIcon.vue';

defineOptions({ name: 'CustomTag' });

defineProps({
  /** tag的内容 */
  label: {
    type: String,
    default: '',
  },
  /** tag的类型 */
  type: {
    type: String as PropType<'primary' |'success' | 'warning' | 'info' | 'danger'>,
    default: 'info',
  },
  /** 感叹号hover的提示内容 */
  content: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang='scss'>
$primary-bg-color: #e8f2ff;
$primary-border-color: #d1e4ff;
$primary-text-color: #1777ff;
$success-bg-color: #e8faec;
$success-border-color: #d0f3d7;
$success-text-color: #14c539;
$danger-bg-color: #ffeded;
$danger-border-color: #ffdbda;
$danger-text-color: #ff4948;
$info-bg-color: #f5f6fa;
$info-border-color: #dcdfe6;
$info-text-color: #8c8c8c;

.custom-tag {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .custom-tag-label {
    position: relative;
    font-size: 12px;
    color: #fff;
    width: 56px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
  }

  .info {
    background-color: $info-bg-color;
    border: 1px solid $info-border-color;
    color: $info-text-color;
  }

  .success {
    background-color: $success-bg-color;
    border: 1px solid $success-border-color;
    color: $success-text-color;
  }

  .warning {
    background-color: $primary-bg-color;
    border: 1px solid $primary-border-color;
    color: $primary-text-color;
  }

  .danger {
    background-color: $danger-bg-color;
    border: 1px solid $danger-border-color;
    color: $danger-text-color;
  }

  .primary {
    background-color: $primary-bg-color;
    border: 1px solid $primary-border-color;
    color: $primary-text-color;
  }

  .el-tooltip__trigger {
    position: absolute;
    right: -20px;
    display: flex;
    align-items: center;
    background: none;
  }

  .svg-icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
    border: none !important;

    &.info {
      color: $info-text-color;
    }

    &.success {
      color: $success-text-color;
    }

    &.warning {
      color: $primary-text-color;
    }

    &.danger {
      color: $danger-text-color;
    }

    &.primary {
      color: $primary-text-color;
    }

  }
}
</style>
